export default __webpack_public_path__ + "static/media/Velocity-Home_11.94dd7a16.jpg";